function makeRequest(form, action, data, cb, forms) {
  const FD = new FormData();

  FD.append('action', action);
  FD.append('nonce', ajaxnonce);
  data.forEach((item) =>
    FD.append(item, form.querySelector(`[name="${item}"]`).value)
  );

  fetch(ajaxurl, {
    method: 'POST',
    body: FD,
    credentials: 'same-origin',
  })
    .then((res) => res.json())
    .then(cb)
    .catch(() => {
      updateForms(forms, 'There was an error processing your request.');
    });
}

const updateForms = (forms) => (msg) => {
  forms.forEach((form) => {
    form.innerHTML = `<p class="response">${msg}</p>`;
  });
};

export { makeRequest, updateForms };
